export const RFQ_CREATE_REQUEST = "RFQ_CREATE_REQUEST";
export const RFQ_CREATE_SUCCESS = "RFQ_CREATE_SUCCESS";
export const RFQ_CREATE_FAIL = "RFQ_CREATE_FAIL";
export const RFQ_CREATE_RESET = "RFQ_CREATE_RESET";

export const RFQ_LIST_REQUEST = "RFQ_LIST_REQUEST";
export const RFQ_LIST_SUCCESS = "RFQ_LIST_SUCCESS";
export const RFQ_LIST_FAIL = "RFQ_LIST_FAIL";
export const RFQ_LIST_RESET = "RFQ_LIST_RESET";

export const RFQ_GET_REQUEST = "RFQ_GET_REQUEST";
export const RFQ_GET_SUCCESS = "RFQ_GET_SUCCESS";
export const RFQ_GET_FAIL = "RFQ_GET_FAIL";
export const RFQ_GET_RESET = "RFQ_GET_RESET";

export const QUOTE_SUBMIT_REQUEST = "QUOTE_SUBMIT_REQUEST";
export const QUOTE_SUBMIT_SUCCESS = "QUOTE_SUBMIT_SUCCESS";
export const QUOTE_SUBMIT_FAIL = "QUOTE_SUBMIT_FAIL";
export const QUOTE_SUBMIT_RESET = "QUOTE_SUBMIT_RESET";

export const RFQ_QUOTE_LIST_REQUEST = "RFQ_QUOTE_LIST_REQUEST";
export const RFQ_QUOTE_LIST_SUCCESS = "RFQ_QUOTE_LIST_SUCCESS";
export const RFQ_QUOTE_LIST_FAIL = "RFQ_QUOTE_LIST_FAIL";
export const RFQ_QUOTE_LIST_RESET = "RFQ_QUOTE_LIST_RESET";

export const QUOTE_ACCEPT_REQUEST = "QUOTE_ACCEPT_REQUEST";
export const QUOTE_ACCEPT_SUCCESS = "QUOTE_ACCEPT_SUCCESS";
export const QUOTE_ACCEPT_FAIL = "QUOTE_ACCEPT_FAIL";
export const QUOTE_ACCEPT_RESET = "QUOTE_ACCEPT_RESET";

export const LEAD_LIST_REQUEST = "LEAD_LIST_REQUEST";
export const LEAD_LIST_SUCCESS = "LEAD_LIST_SUCCESS";
export const LEAD_LIST_FAIL = "LEAD_LIST_FAIL";
export const LEAD_LIST_RESET = "LEAD_LIST_RESET";
